module.exports = __webpack_public_path__ + "img/img-main-bg04M.7214e731.png";